import script from "./CurrencyInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&setup=true&lang=ts"

import "./CurrencyInput.vue?vue&type=style&index=0&id=7d853837&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d853837"]])

export default __exports__